/**
 * The type of the action which signals the keyboard shortcuts dialog should
 * be displayed.
 *
 * {
 *     type: OPEN_KEYBOARD_SHORTCUTS_DIALOG
 * }.
 */
export const OPEN_KEYBOARD_SHORTCUTS_DIALOG
    = 'OPEN_KEYBOARD_SHORTCUTS_DIALOG';

/**
 * The type of the action which signals that a keyboard shortcut should be unregistered.
 */
export const UNREGISTER_KEYBOARD_SHORTCUT = 'UNREGISTER_KEYBOARD_SHORTCUT';

/**
 * The type of the action which signals that a keyboard shortcut should be registered.
 */
export const REGISTER_KEYBOARD_SHORTCUT = 'REGISTER_KEYBOARD_SHORTCUT';
